import { Navbar } from "@/components/Navbar";
import { Hero } from "@/components/Hero";
import { About } from "@/components/About";
import { WhyChoose } from "@/components/WhyChoose";
import { Programs } from "@/components/Programs";
import { InPersonTraining } from "@/components/InPersonTraining";
import { Gallery } from "@/components/Gallery";
import { TestimonialsSection } from "@/components/TestimonialsSection";
import { Referral } from "@/components/Referral";
import { FAQ } from "@/components/FAQ";
import { ApplicationForm } from "@/components/ApplicationForm";
import { Footer } from "@/components/Footer";

export default function Landing() {
  return (
    <div className="bg-[#0A0A0A] min-h-screen overflow-x-hidden">
      <Navbar />
      <Hero />
      <About />
      <WhyChoose />
      <Programs />
      <InPersonTraining />
      <Gallery />
      <TestimonialsSection />
      <Referral />
      <FAQ />
      <ApplicationForm />
      <Footer />
    </div>
  );
}
